/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

/**
 * 右下：LowerRight
 */
export type Keys = string[];
export interface Body {
  keys: Keys;
}
export type ConfigList = {
  id: number;
  /**
   * 配置Key 右下：LowerRight
   */
  key: string;
  /**
   * 名称
   */
  name: string;
  /**
   * 封面cosid
   */
  cover_id: string;
  /**
   * 跳转链接
   */
  link: string;
  /**
   * 拓展信息
   */
  ext_info: string;
  /**
   * 状态 1编辑中 2已发布
   */
  status: number;
  /**
   * 开始时间
   */
  start_time: number;
  /**
   * 结束时间
   */
  end_time: number;
}[];
export interface PublicAdvertisingConfigRes {
  code: string;
  msg: string;
  nonce: string;
  data: Data;
}
export interface Data {
  config_list: ConfigList;
}

const PublicAdvertisingConfig = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<PublicAdvertisingConfigRes>(
    '/wemeet-tapi',
    '/v2/activities/public/advertising/config',
    data,
    ctx,
  );

  return res;
};

export default PublicAdvertisingConfig;
